'use client'
import { useMemo, useState, useEffect } from "react"
import { createPortal } from "react-dom"
import { useTableMapState } from "./TableMapState"
import { FilterByCampaign } from "./FilterByCampaign"
import { FilterByProduct } from "./FilterByProduct"
import { FilterByCrmLeads } from "./FilterByCrmLeads"
import Dropdown from "@/migrated-widgets/table-map/components/molecules/Dropdown"
import { DropdownItem } from "@/migrated-widgets/table-map/components/molecules/Dropdown/Item"
import { ChevronDownIcon } from "@/migrated-widgets/table-map/components/icons/ChevronDownIcon"
import { useGlobal } from "@/migrated-widgets/table-map/contexts/GlobalState"

interface TableMapFiltersProps {
  portalId?: string; // If provided, renders via portal to this element id
}

const TableMapFiltersContent: React.FC = () => {
  const { onlyMap, locationsBy, transactions } = useTableMapState();
  const hasLeads = transactions.some((t) => t.transactionType === 'L');
  const [salesType, setSalesType] = useState("");
  const selectedSalesType: string = useMemo(() => {
    if (!salesType) return "All";
    return salesType;
  }, [salesType]);

  return (
    <div className="flex items-center gap-4">
      {!onlyMap && hasLeads && <FilterByCrmLeads />}
      {locationsBy === 'product' && <FilterByProduct />}
      {locationsBy === 'campaign' && <FilterByCampaign />}
      {/* DU-97: Temporarily hidden Sales Type filter
            {!onlyMap && (
                <div className="min-w-40 max-w-44">
                    <Dropdown
                        closeOnClick={true}
                        dropdownList={{ className: 'text-sm border border-gray-200 rounded-lg shadow-md', width: 'w-full' }}
                        trigger={
                            <button className="w-full border font-medium border-gray-200 text-gray-700 px-3 py-1.5 rounded-lg text-sm flex gap-2 justify-between items-center hover:bg-gray-50">
                                <div className="flex items-center gap-1.5">
                                    <span className="text-gray-500 text-nowrap">Sales Type:</span>
                                    <span>{selectedSalesType}</span>
                                </div>
                                <ChevronDownIcon className="w-3.5" />
                            </button>
                        }
                        listFooter={
                            <DropdownItem onClick={() => setSalesType("")} className="px-3 py-2 text-gray-500 font-semibold border-t border-gray-100" onHoverClass="hover:bg-gray-50 duration-200">
                                All
                            </DropdownItem>
                        }
                    >
                        <DropdownItem onClick={() => setSalesType("Personal")} className="px-3 py-2 text-gray-700" onHoverClass="hover:bg-gray-50 duration-200">
                            Personal
                        </DropdownItem>
                        <DropdownItem onClick={() => setSalesType("Fleet")} className="px-3 py-2 text-gray-700" onHoverClass="hover:bg-gray-50 duration-200">
                            Fleet
                        </DropdownItem>
                        <DropdownItem onClick={() => setSalesType("Wholesale")} className="px-3 py-2 text-gray-700" onHoverClass="hover:bg-gray-50 duration-200">
                            Wholesale
                        </DropdownItem>
                    </Dropdown>
                </div>
            )}
            */}
    </div>
  )
}

const TableMapFilters: React.FC<TableMapFiltersProps> = ({ portalId }) => {
  const { params } = useGlobal();
  const [portalContainer, setPortalContainer] = useState<HTMLElement | null>(null);

  // Determine the portal target id
  const targetId = portalId || `widget-filters-portal-${params.widgetId}`;

  useEffect(() => {
    // Find the portal container after mount
    const container = document.getElementById(targetId);
    setPortalContainer(container);
  }, [targetId]);

  // If portal container exists, render via portal
  if (portalContainer) {
    return createPortal(<TableMapFiltersContent />, portalContainer);
  }

  // Fallback: render inline if portal container not found
  return <TableMapFiltersContent />;
}

export { TableMapFilters, TableMapFiltersContent }
